import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { CardShape } from 'pages/mkt/components'
import { format } from '@dt/fe-utils'
import './index.scss'

interface IProps {
  type: 'small' | 'big';
  productInfo: IEGiftCardInfo;
  clickEvent?: (e?: any) => void;
  btnText?: string;
}

const GiftCardProduct: FC<IProps> = (props) => {
  const {
    type,
    productInfo,
    clickEvent,
    btnText = i18n.t('mkt.member.buy')
  } = props
  const getRecommend = (reloadAmounts: any) => {
    const list: any = []
    reloadAmounts.map((item: any) => {
      if (item.ifRecommend) list.push(item)
    })
    return list
  }
  return (
    <>
      {
        productInfo && (
          <div className='mkt-giftcard-product'>
            <div className='small-block'>
              <div className={`mgcp-pic${!productInfo.covers[0].shapes || productInfo.covers[0].shapes[0] === 'rectangle' ? ' rectangle' : ''}`}>
                <CardShape cardFace={productInfo.covers[0].url} shape={productInfo.covers[0].shapes ? productInfo.covers[0].shapes[0] : 'rectangle'} isScale={false}></CardShape>
              </div>
              <div className='mgcp-info'>
                <div className='small-name'>{productInfo.giftcardName}</div>
                {
                  productInfo.isRecharge &&
                    <div className={`amount${productInfo.balance === 0 ? ' warm-tip' : ''}`}>{i18n.t('mkt.common.balance')}: {format.toPrice(productInfo.balance)}</div>
                }
                {
                  !!getRecommend(productInfo.reloadAmounts).length &&
                    <div className='card-recommend'>
                      {
                        getRecommend(productInfo.reloadAmounts).map((reloadAmount: any, index: number) => {
                          if (type === 'small' && index > 1) {
                            return
                          } else {
                            return <span key={reloadAmount.id} className='card-recommend-item'><span className='card-recommend-item-bg'>{i18n.t('mkt.giftCard.recharge')}{format.toPrice(reloadAmount.recharge, 0, false)}{reloadAmount.give > 0 && i18n.t('mkt.giftCard.giveAway')}{reloadAmount.give > 0 && format.toPrice(reloadAmount.give, 0, false)}</span></span>
                          }
                        })
                      }
                    </div>
                }
                <div className='small-btn' onClick={clickEvent}>{btnText}</div>
              </div>
            </div>
          </div>
        )
      }
    </>
  )
}

export default observer(GiftCardProduct)
